module.exports = __webpack_public_path__ + "img/SC3-finance.0c1a32a2.svg";